module.exports = __webpack_public_path__ + "static/media/Event-Carousels-Wedding.979586c6.webp";